<template>
  <v-app-bar app fixed clipped-left elevation="1" color="white" height="100px">
    <v-img
      src="../assets/logo_cetim.png"
      id="logo"
      alt="BDSR"
      :height="logo_height"
      :width="logo_width"
      contain
      style="position: absolute"
    >
    </v-img>

    <v-container fluid class="pa-0 ma-0">
      <v-row
        align="center"
        justify="start"
        class="m-0 p-0"
        v-if="this.$vuetify.breakpoint.lgAndUp"
      >
        <v-col cols="12">
          <h1 class="text-h4 text-center pb-2">{{ $t("title") }}</h1>
          <h1 class="text-h6 text-center">{{ $t("nav." + title) }}</h1>
        </v-col>
      </v-row>
      <v-row align="center" justify="start" class="m-0 p-0" v-else>
        <v-col cols="4"></v-col>
        <v-col cols="">
          <h1 class="text-h4 pb-2">BDSR Web</h1>
          <h1 class="text-h6">{{ $t("nav." + title) }}</h1>
        </v-col>
      </v-row>
    </v-container>
  </v-app-bar>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    title: String,
  },
  computed: {
    ...mapGetters(["identity", "user"]),
    logo_height() {
      return this.$vuetify.breakpoint.name === "xs" ? 50 : 100;
    },
    logo_width() {
      return this.$vuetify.breakpoint.name === "xs" ? 110 : 220;
    },
  },
  mounted() {
    if (this.identity.lang) {
      this.$i18n.locale = this.identity.lang;
    }
    if (this.user.access_token) {
      // console.log("ON PLACE LE TOKEN EN INTERCEPTORS AXIOS");
      this.axios.interceptors.request.use(async (config) => {
        config.headers.common.Authorization = "Bearer " + this.user.id_token;
        return config;
      });
    }
  },
};
</script>